// Что витрина делает, когда сессии больше нет.
//
// Витрина целиком живёт за сессией: анонимному человеку здесь нечего показать.
// Раньше 401 не перехватывался нигде, и протухшая cookie выглядела как поломка —
// каждая карточка рисовала «Не удалось загрузить» с кнопкой «Повторить»,
// которая честно повторяла запрос и получала тот же 401 (аудит 2026-08-20, К2).
//
// Правильная реакция ровно одна: увести на вход и вернуть обратно на ту же
// страницу. Это делается здесь, а не в компонентах: перехват в одном месте —
// единственный способ не забыть его в следующей карточке.
//
// Сам адрес входа живёт в `lib/sso-url.ts`: он нужен ещё двум поверхностям,
// не имеющим к 401 отношения (кнопка «Выйти», ссылка на текст про cookie).

import { ssoOrigin, ssoSignInUrl } from "./sso-url";

/** Коды и статусы, означающие «сессии нет» (tRPC отдаёт и то, и другое). */
export function isUnauthorized(error: unknown): boolean {
	const data = (error as { data?: { code?: string; httpStatus?: number } } | null)?.data;
	return data?.code === "UNAUTHORIZED" || data?.httpStatus === 401;
}

/**
 * Уход на форму входа. Однократный: раздел витрины открывается десятком
 * запросов сразу, и каждый вернёт свой 401 — без флага мы назначили бы
 * `location` десять раз подряд и потеряли бы часть истории браузера.
 *
 * Флаг модульный, а не в сторе: он обязан пережить размонтирование дерева,
 * которое произойдёт при навигации, и не должен участвовать в рендере.
 *
 * `replace`, а не `assign`: страница, с которой мы уходим, без сессии
 * нерабочая, и «Назад» из формы входа возвращал бы на неё, чтобы через
 * мгновение снова уехать сюда же. Кнопка «Назад» переставала работать ровно
 * там, где человек ею и пользуется.
 */
let leaving = false;

export function redirectToSignIn(): void {
	if (leaving || typeof window === "undefined") return;
	leaving = true;
	window.location.replace(ssoSignInUrl());
}

/** Только для тестов: сбросить флаг однократного ухода. */
export function __resetSignInRedirect(): void {
	leaving = false;
}

/**
 * Уход в мастер онбординга. Тот же `replace` и та же защёлка, что у входа:
 * человек с непройденным мастером на витрине делать ничего не может, и
 * возвращать его сюда «Назад» — значит гонять по кругу.
 */
export function redirectToOnboarding(): void {
	if (leaving || typeof window === "undefined") return;
	leaving = true;
	window.location.replace(`${ssoOrigin()}/onboarding`);
}
